export const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.2 },
  },
  exit: {
    opacity: 0,
    y: 20,
    transition: { duration: 0.6, ease: "easeIn" },
  },
};

export const wordVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } },
  exit: {
    opacity: 0,
    scale: 0.8,
    transition: { duration: 0.5, ease: "easeIn" },
  },
};

export const scrollVariantsLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    x: 50,
    transition: { duration: 0.6, ease: "easeIn" },
  },
};
export const scrollVariantsRight = {
  hidden: { opacity: 0, x: 50 }, 
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    x: -50, // exit to left
    transition: { duration: 0.6, ease: "easeIn" },
  },
};

export const upAndDown = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 0,
    y: -50,
    transition: {
      duration: 0.5,
      ease: "easeIn",
    },
  },
};
export const downAndUp = {
  hidden: {
    opacity: 0,
    y: -50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 0.5,
      ease: "easeIn",
    },
  },
};

